import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  TextField,
  Typography,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { CreatePatientForm } from "types";
import { familyMedicalHistoryOptions } from "validations/patientSchemas";

function MedicationHistorySection() {
  const {
    control,
    formState: { errors },
  } = useFormContext<CreatePatientForm>();

  return (
    <Box className="space-y-6 mt-8">
      <Typography variant="h6" className="text-xl font-medium">
        Medication History
      </Typography>

      <Box className="grid grid-cols-2 gap-4">
        <Controller
          name="pastSurgeries"
          control={control}
          render={({ field }) => (
            <TextField
              id="past-surgeries"
              label="Past Surgeries (optional)"
              variant="outlined"
              fullWidth
              multiline
              error={!!errors.pastSurgeries}
              helperText={errors.pastSurgeries?.message as string}
              {...field}
            />
          )}
        />

        <Controller
          name="pastHospitalizations"
          control={control}
          render={({ field }) => (
            <TextField
              id="past-hospitalizations"
              label="Past Hospitalizations (optional)"
              variant="outlined"
              fullWidth
              multiline
              error={!!errors.pastHospitalizations}
              helperText={errors.pastHospitalizations?.message as string}
              {...field}
            />
          )}
        />
      </Box>

      <Controller
        name="familyMedicalHistory"
        control={control}
        render={({ field }) => (
          <FormControl error={!!errors.familyMedicalHistory} className="w-full">
            <FormLabel
              component="legend"
              className="text-base font-medium mb-2"
            >
              Family Medical History
            </FormLabel>
            <FormGroup row>
              {familyMedicalHistoryOptions.map((option) => (
                <FormControlLabel
                  key={option}
                  control={
                    <Checkbox
                      checked={field.value?.includes(option) || false}
                      onChange={(e) => {
                        const currentValue = field.value || [];
                        if (e.target.checked) {
                          field.onChange([...currentValue, option]);
                        } else {
                          field.onChange(
                            currentValue.filter((item) => item !== option)
                          );
                        }
                      }}
                    />
                  }
                  label={option}
                />
              ))}
            </FormGroup>
            {errors.familyMedicalHistory && (
              <FormHelperText>
                {errors.familyMedicalHistory.message as string}
              </FormHelperText>
            )}
          </FormControl>
        )}
      />
    </Box>
  );
}

export default MedicationHistorySection;
